import React, { useState } from 'react';
import { Checkbox, Fade, FormControlLabel, TableHead } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import './CollectiveAgreement.scss';
import { TableContainer } from '@mui/material';
import { Table } from '@mui/material';
import { TableRow } from '@mui/material';
import { TableBody } from '@mui/material';
import { TableCell } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useCollectiveAgreement } from '../../providers/CollectiveAgreement';

export default function CollectiveAgreement({ratesWithDates}) {
  const [checked, setChecked] = useState(false);
  const { t } = useTranslation();
  const effDateFromArray = (new Date(ratesWithDates.effDateFrom)).toString().split(' ');
  const effDateToArray = (new Date(ratesWithDates.effDateTo)).toString().split(' ');
  const collectiveAgreementContext = useCollectiveAgreement();

  const handleCheck = () => {
    setChecked((prev) => !prev);
  };

  const splitDNrates = (rates, size: number) => {
    let result: Array<any> = [];
    let tempRates:any = [...rates]; 
    while (tempRates.length > 0) {
      result.push(tempRates.splice(0, size));
    }
    return result;
  };

  const openDbmLink = () => {
    collectiveAgreementContext.openAcpaUrl();
  }

  return (
    <div className='collective-agreement-container'>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            icon={<AddCircleIcon fontSize='large' className='iconAdd' />}
            checkedIcon={<RemoveCircleOutlineOutlinedIcon fontSize='large' className='iconRemove' />}
            onChange={handleCheck}
            inputProps={{ 'aria-label': `${t('collectiveAgreement.expandLabel')}` }}
            name='checkbox'
          />
        }
        label={t('collectiveAgreement.expandLabel')}
      />
      <div className='collective-agreement-content'>
        <Fade in={checked} unmountOnExit={true}>
          <div>
            <p className='hight-lighted'>
              <span className='item-ref'>{t('collectiveAgreement.agreement1-ref')}</span>
              <span className='collective-agreement-details'>
                {t('collectiveAgreement.agreement1-text')} 
                <button className='collective-agreement-acpa-link' onClick={openDbmLink}>
                  {t('collectiveAgreement.agreement1-link')}
                </button>
                <button className='collective-agreement-acpa-link collective-agreement-acpa-link--icon' onClick={openDbmLink}>
                  <i className='icon-external-link'></i>
                </button>                
              </span>
            </p>
            <p>
              <span className='item-ref'>{t('collectiveAgreement.agreement2-ref')}</span> <span className="collective-text">{t('collectiveAgreement.agreement2-text')}</span>
            </p>
            <div className='collective-table'>
              {ratesWithDates.results && splitDNrates(ratesWithDates.results, 6).map((val, index) =>   (
                  <TableContainer key={index}>
                    <Table aria-label='DBM vs MBG'>
                      <TableHead>
                        <TableRow>
                          <TableCell> {t('collectiveAgreement.th-DBM')} </TableCell>
                          <TableCell>
                            {t('collectiveAgreement.th-MBG')} <br /> {t('collectiveAgreement.th-block')}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {val.map((row, id) =>  (
                          <TableRow key={id}>
                            <TableCell component='th' scope='row' align='left'>
                              {row.dbm}
                            </TableCell>
                            <TableCell align='left'> {row.mbgblock}/{row.mbgreserve} </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )
              )}
            </div>
            <p className="effective-date" >{t('collectiveAgreement.effectiveDate')} {effDateFromArray[1]} {effDateFromArray[2]}, {effDateFromArray[3]} - {effDateToArray[1]} {effDateToArray[2]}, {effDateToArray[3]}</p>
           </div>
        </Fade>
      </div>
    </div>
  );
}
